import { AxiosResponse } from 'axios';
import Apis from '../apis';

export type OauthFieldsDto = {
  client_id: string;
  response_type: string;
  redirect_uri?: string;
  scope: string;
  state?: string;
  code_challenge?: string;
  code_challenge_method?: string;
};

export type RegisterDto = {
  nome: string;
  nomeusuario: string;
  senha: string;
  senha_confirmacao: string;
};

export type LoginDto = {
  nomeusuario: string;
  senha: string;
};

export type LoginRespDto = {
  id_token: string;
  access_token: string;
  callback_uri: string;
};

export type AutenticacaoAtiva = {
  usuario_uuid: string;
  usuario_nome: string;
};

export class AuthDataSource {
  async register({ nome, nomeusuario, senha, senha_confirmacao }: RegisterDto, oauth: OauthFieldsDto): Promise<AxiosResponse<LoginRespDto>> {
    return await Apis.ApiAuth.post('/register', {
      nome,
      nomeusuario,
      senha,
      senha_confirmacao,
      ...oauth,
    });
  }

  async login(login: LoginDto | AutenticacaoAtiva, oauth: OauthFieldsDto): Promise<AxiosResponse<LoginRespDto>> {
    const data = {
      ...oauth,
    } as Partial<LoginDto & AutenticacaoAtiva & OauthFieldsDto>;
    if ((login as AutenticacaoAtiva).usuario_uuid) {
      data.usuario_uuid = (login as AutenticacaoAtiva).usuario_uuid;
    } else {
      data.nomeusuario = (login as LoginDto).nomeusuario;
      data.senha = (login as LoginDto).senha;
    }
    return await Apis.ApiAuth.post('/login', data);
  }

  async autenticacoesAtivas(): Promise<AxiosResponse<AutenticacaoAtiva[]>> {
    return await Apis.ApiAuth.get('/autenticacoesativas');
  }

  async logout(): Promise<AxiosResponse<void>> {
    return await Apis.ApiAuth.get('/logout');
  }
  async alterarSenha(senha_antiga: string, senha: string, senha_confirmacao: string): Promise<AxiosResponse<{ email: string }>> {
    return await Apis.ApiAuth.post('/senha', { senha_antiga, senha, senha_confirmacao });
  }
}
